import React from 'react';
import { Switch as HSwitch } from '@headlessui/react';
import clsx from 'clsx';

export default function Switch({
  name,
  id,
  label,
  description,
  value,
  required,
  onChange,
  size = 'small',
  ...props
}) {
  return (
    <HSwitch.Group
      as="div"
      className="flex items-center justify-between gap-x-4 flex-1"
    >
      {label && (
        <span className="flex-grow flex flex-col">
          <HSwitch.Label className="font-semibold text-gray-800">
            {label}
          </HSwitch.Label>
          {description && (
            <HSwitch.Description className="text-gray-700">
              {description}
            </HSwitch.Description>
          )}
        </span>
      )}

      <HSwitch
        name={name}
        id={id}
        checked={value}
        required={required}
        onChange={() => onChange({ target: { name, value: !value } })}
        className={clsx(
          value ? 'bg-chocolate-600' : 'bg-gray-200',
          'relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-chocolate-600',
          {
            'h-4 w-7': size === 'small',
            'h-6 w-11': size === 'medium',
          },
        )}
        {...props}
      >
        <span
          aria-hidden="true"
          className={clsx(
            'pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
            {
              'h-3 w-3': size === 'small',
              'translate-x-3': size === 'small' && value,
              'h-5 w-5': size === 'medium',
              'translate-x-5': size === 'medium' && value,
            },
          )}
        />
      </HSwitch>
    </HSwitch.Group>
  );
}
